<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
.aaaaa {
  display: flex;
  flex-direction: column;
  background-color: #eef1f6;
  padding: 10px;
  box-sizing: border-box;
}

.bbbbb {
  background: #FFFFFF;
  min-height: 83vh;
  padding: 10px;
  box-sizing: border-box;
}
</style>
